module.exports = __webpack_public_path__ + "img/plus.69e95422.svg";